/* eslint-disable react/prop-types */
import { CustomPersonIcon } from '@sketchnote/icons';
import * as React from 'react';
import {
  components as SelectComponents,
  GroupTypeBase,
  OptionTypeBase,
  SingleValueProps,
  StylesConfig,
} from 'react-select';

import { Avatar } from '../avatar';

type OptionType = OptionTypeBase & { label: string; value: string };
type GroupType = GroupTypeBase<OptionType>;

export const userSelectStyles_custom: StylesConfig<OptionType, boolean, GroupType> = {
  control: (styles) => ({
    ...styles,
    backgroundColor: '#ffff',
    padding: '0px 1.2rem 0px 0px',
    border: 'none',
    fontWeight: 400,
    fontSize: '1.6rem',
    color: '#131720',
    width: '100%',
  }),
  menu: (styles) => ({
    ...styles,
    borderRadius: '6px',
    width: '100%',
    marginTop: '0.7rem',
    background: '#fff',
    boxShadow: '0px 2px 12px rgba(19, 23, 32, 0.08)',
    padding: '0.6rem 0.6rem',
  }),
  menuList: (styles) => ({
    ...styles,
    padding: '0px',
  }),
  group: (styles) => ({
    ...styles,
    padding: '0 0 0.5rem 0',
  }),
  groupHeading: (styles) => ({
    ...styles,
    fontWeight: 400,
    color: '#878A92',
    fontSize: '14px',
    padding: '0.6rem 0.8rem',
    textTransform: 'none',
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? '#F6F7F9'
        : isSelected
        ? '#EEF1FC'
        : isFocused
        ? '#F6F7F9'
        : 'inherit',
      padding: '0.6rem 0.6rem 0.6rem 0.4rem',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      marginBottom: '0.5rem',
      color: isDisabled ? '#ccc' : '#131720',
      cursor: isDisabled ? 'not-allowed' : 'default',
      borderRadius: '6px',
      ':active': {
        ...styles[':active'],
        backgroundColor: '#EEF1FC',
      },
    };
  },
  multiValue: (styles) => ({
    ...styles,
    margin: '0',
    backgroundColor: 'inherit',
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    ':hover': {
      background: '#EEF1FC',
    },
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};
export const userSelectStyles_Custom_Approval: StylesConfig<OptionType, boolean, GroupType> = {
  control: (styles) => ({
    ...styles,
    backgroundColor: '#ffff',
    padding: '0px 1.2rem 0px 0px',
    border: '1px solid F6F7F9',
    fontWeight: 400,
    fontSize: '1.2rem',
    color: '#131720',
    width: '100%',
  }),
  menu: (styles) => ({
    ...styles,
    borderRadius: '6px',
    width: '100%',
    marginTop: '0.7rem',
    background: '#fff',
    boxShadow: '0px 2px 12px rgba(19, 23, 32, 0.08)',
    padding: '0.6rem 0.6rem',
  }),
  menuList: (styles) => ({
    ...styles,
    padding: '0px',
  }),
  group: (styles) => ({
    ...styles,
    padding: '0 0 0.5rem 0',
  }),
  groupHeading: (styles) => ({
    ...styles,
    fontWeight: 400,
    color: '#878A92',
    fontSize: '10px',
    padding: '0.6rem 0.8rem',
    textTransform: 'none',
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? '#F6F7F9'
        : isSelected
        ? '#EEF1FC'
        : isFocused
        ? '#F6F7F9'
        : 'inherit',
      padding: '0.6rem 0.6rem 0.6rem 0.4rem',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      marginBottom: '0.5rem',
      color: isDisabled ? '#ccc' : '#131720',
      cursor: isDisabled ? 'not-allowed' : 'default',
      borderRadius: '6px',
      ':active': {
        ...styles[':active'],
        backgroundColor: '#EEF1FC',
      },
    };
  },
  multiValue: (styles) => ({
    ...styles,
    margin: '0',
    backgroundColor: 'inherit',
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    ':hover': {
      background: '#EEF1FC',
    },
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

// export const UserSelectDropDownIndicator = () => <ChevronDownIcon className="text-gray-500" />;

export const UserSelectSingleValue_custom:
  | React.ComponentType<SingleValueProps<OptionType, GroupType>>
  | undefined = (props) => (
  <div className="flex items-center">
    <Avatar src={props.data.avatar} type="photo" size="sm" name={props.data.label} />
    <span className="ml-8 text-sm">{props.data.label}</span>
  </div>
);

export const UserSelectOption_custom: any = (props) => (
  <SelectComponents.Option {...props}>
    <div className="flex items-center">
      <Avatar src={props.data.avatar} type="photo" size="sm" name={props.data.label} />
      <span className="ml-8 text-sm">{props.data.label}</span>
    </div>
  </SelectComponents.Option>
);

export const UserSelectOption_Approval: any = (props) => (
  <SelectComponents.Option {...props}>
    <div className="flex items-center">
      <Avatar src={props.data.avatar} type="photo" size="sm" name={props.data.label} />
      <span className="ml-8 text-sm">{props.data.label}</span>
    </div>
  </SelectComponents.Option>
);

export const UserSelectMultiValueLabel_custom: React.ComponentType<any> = (props) => (
  <div className="flex items-center">
    <Avatar src={props.data.avatar} type="photo" size="sm" name={props.data.label} />
    <span className="ml-8 text-sm">{props.data.label}</span>
  </div>
);
export const UserSelectMultiValueLabel_Approval: React.ComponentType<any> = (props) => (
  <div className="flex items-center">
    <Avatar src={props.data.avatar} type="photo" size="sm" name={props.data.label} />
    <span className="ml-8 text-sm">{props.data.label}</span>
  </div>
);

export const UserSelectPlaceholder_custom = ({
  label = 'Unassigned',
  labelClassName,
}: {
  label?: string;
  labelClassName?: string;
}): JSX.Element => (
  <div className="flex items-center">
    <CustomPersonIcon wrapperClass="text-gray-400 mr-5" size={20} />
    &nbsp;&nbsp;<span className={labelClassName}>{label}</span>
  </div>
);
